import React from 'react';
import { motion } from 'framer-motion';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import style from './Footer.module.css';

const Footer = () => {
  const socialLinks = [
    { icon: FaFacebookF, href: 'https://www.facebook.com/schoolbilisim', label: 'Facebook' },
    { icon: FaTwitter, href: 'https://twitter.com/bilisimschool', label: 'Twitter' },
    { icon: FaLinkedinIn, href: 'https://www.linkedin.com/company/bilisim-school', label: 'LinkedIn' },
    { icon: FaInstagram, href: 'https://www.instagram.com/bilisimschool/', label: 'Instagram' }
  ];

  return (
    <footer className={style.footer}>
      <div className={style.footerGradient} />
      
      <div className={style.footerContent}>
        {/* Main Content */}
        <div className={style.footerMain}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className={style.footerBrand}
          >
            <h3 className={style.footerTitle}>Talent14</h3>
            <p className={style.footerDescription}>
              K-12'de Güvenli Yapay Zeka Öncüsü. Geleceğin eğitim platformu.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className={style.footerLinks}
          >
            <h4 className={style.footerSectionTitle}>Hızlı Linkler</h4>
            <Link to="/" className={style.footerLink}>Anasayfa</Link>
            <a href="https://app.talent14.com/" target="_blank" rel="noopener noreferrer" className={style.footerLink}>
              Sisteme Giriş
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className={style.footerLegal}
          >
            <h4 className={style.footerSectionTitle}>Politika/Yasal</h4>
            <Link to="/ai-policy" className={style.footerLink}>
              Yapay Zeka Politikamız
            </Link>
            <Link to="/kvkk" className={style.footerLink}>
              KVKK
            </Link>
            <Link to="/gizlilik-ve-cerez-politikasi" className={style.footerLink}>
              Gizlilik ve Çerez Politikası
            </Link>
            <Link to="/uyelik-sozlesmesi-ve-site-kullanim-kosullari" className={style.footerLink}>
              Üyelik Sözleşmesi
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className={style.footerSocial}
          >
            <h4 className={style.footerSectionTitle}>İletişim</h4>
            <a href="mailto:info@talent14.com" className={style.footerEmail}>
              <FaEnvelope aria-hidden="true" />
              info@talent14.com
            </a>
            <div className={style.socialIcons}>
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={style.socialIcon}
                  whileHover={{ scale: 1.2, rotate: 5 }}
                  whileTap={{ scale: 0.9 }}
                  aria-label={social.label}
                >
                  <social.icon />
                </motion.a>
              ))}
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 1 }}
          className={style.footerBottom}
        >
          <div className={style.footerLine} />
          <div className={style.footerBottomRow}>
            <p className={style.footerCopyright}>
              Copyright &copy; {new Date().getFullYear()} TALENT14. Tüm hakları saklıdır.
            </p>
            <a href="mailto:info@talent14.com" className={style.footerBottomEmail}>
              info@talent14.com
            </a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
